function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48.5,29c-0.2-2.7-1.1-5.3-2.6-7.6c-1.5-2.3-3.5-4.2-5.8-5.5c-2.4-1.3-5-2-7.7-2.1c-2.7-0.1-5.4,0.6-7.8,1.8 s-4.5,3-6,5.3c-1.6,2.2-2.5,4.8-2.9,7.5c-0.3,2.7,0,5.4,1,7.9c1,2.5,2.6,4.8,4.6,6.5c1.2,1,2.1,2.2,2.8,3.6c0.7,1.4,1,2.9,1,4.5v0.7 c0,0.4,0.2,0.8,0.4,1.1s0.7,0.4,1.1,0.4h0.8v2.5c0,1.3,0.5,2.5,1.4,3.4s2.1,1.4,3.4,1.4c1.3,0,2.5-0.5,3.4-1.4 c0.9-0.9,1.4-2.1,1.4-3.4v-2.5h0.8c0.4,0,0.8-0.2,1.1-0.4s0.4-0.7,0.4-1.1V51c0-1.6,0.4-3.1,1.1-4.5c0.7-1.4,1.6-2.7,2.8-3.7 c2-1.7,3.5-3.8,4.4-6.2C48.3,34.2,48.7,31.6,48.5,29L48.5,29z M33.7,55.8c0,0.5-0.2,0.9-0.5,1.2c-0.3,0.3-0.8,0.5-1.2,0.5 c-0.5,0-0.9-0.2-1.2-0.5c-0.3-0.3-0.5-0.8-0.5-1.2v-2.5h3.5V55.8z M40.9,40.5c-1.4,1.2-2.6,2.7-3.4,4.3s-1.3,3.5-1.5,5.3h-8 c-0.1-1.8-0.6-3.6-1.4-5.3c-0.8-1.6-2-3.1-3.4-4.3c-2.1-1.8-3.6-4.2-4.3-6.9s-0.5-5.5,0.4-8.1c1-2.6,2.7-4.8,4.9-6.4 c2.3-1.6,4.9-2.4,7.7-2.4c2.8,0,5.4,0.8,7.7,2.4c2.3,1.6,4,3.8,5,6.4c1,2.6,1.1,5.4,0.5,8.1C44.5,36.3,43,38.7,40.9,40.5L40.9,40.5z "
});

function SvgDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.bfaa03d87802144c27302b33fb6a0d0f.svg";
export { ForwardRef as ReactComponent };